var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCumulativeDeaths(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9053",
    "data-name": "Group 9053",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 59.72,
    height: 30.1,
    viewBox: "0 0 59.72 30.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4458",
    "data-name": "Rectangle 4458",
    width: 59.72,
    height: 30.1,
    fill: "#ccc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8962",
    "data-name": "Group 8962",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9101",
    "data-name": "Path 9101",
    d: "M157.115,46.776c-.294-.549-.574-1-.791-1.486a10.2,10.2,0,0,1,.234-8.385,11.342,11.342,0,0,1,6.255-6.508c-.038-.056-.058-.106-.073-.105a60.771,60.771,0,0,0-10.279,1.315,25.077,25.077,0,0,0-10.834,5.936c-1.423,1.29-2.713,2.725-4.06,4.1a1.466,1.466,0,0,0-.308.5,11.952,11.952,0,0,1,11.771-.553,50.822,50.822,0,0,1,8.085,5.186",
    transform: "translate(-119.111 -26.756)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9102",
    "data-name": "Path 9102",
    d: "M9,52.739c1.63-.151,3.682-.316,5.728-.546a8.194,8.194,0,0,0,1.791-.5,1.291,1.291,0,0,0,.9-1.4A6.82,6.82,0,0,0,16.4,47.343,30.4,30.4,0,0,0,7.6,37.352a12.387,12.387,0,0,0-1.256-.736,1.613,1.613,0,0,0-2.168.343,17.371,17.371,0,0,0-2.055,2.735A14.755,14.755,0,0,0,.025,48,7.174,7.174,0,0,0,.3,49.608,3.8,3.8,0,0,0,3.963,52.43c1.531.122,3.065.191,5.033.309m-.927-2.811a3.663,3.663,0,1,1,.065-7.314,3.661,3.661,0,1,1-.065,7.314m7.217-.353c.629.246.817.59.444,1.029l-.444-1.029",
    transform: "translate(42.298 -32.105)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9103",
    "data-name": "Path 9103",
    d: "M170.353,144.633c4.245,3.093,8.437,6.29,13.9,6.932a13.281,13.281,0,0,0-1.7,6.175,6.815,6.815,0,0,1,3.863-4.14c-.439-.345-1.016-.6-1.249-1.035a4.845,4.845,0,0,1-.235-1.662l.178-.019.058.822h5.584l.083-.19a11.116,11.116,0,0,1-4.545-5.1,1.851,1.851,0,0,0-.186.321,2.947,2.947,0,0,1-2.82,2.294,13.137,13.137,0,0,1-7.493-1.519c-1.733-.873-3.391-1.892-5.083-2.846l-.287-.159-.064.131",
    transform: "translate(-150.99 -127.64)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9104",
    "data-name": "Path 9104",
    d: "M27.369,177.544c-.242.019-.487.018-.724.06a33.256,33.256,0,0,1-9.111.509c-1.063-.107-2.122-.257-3.181-.4-.992-.13-1.318.153-1.315,1.161,0,.117,0,.233.008.35.068,1.97.609,2.562,2.715,2.712a12.359,12.359,0,0,0,5.7-1.263c1.786-.759,3.518-1.644,5.267-2.486a5.694,5.694,0,0,0,.707-.478l-.066-.169",
    transform: "translate(30.763 -156.826)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9105",
    "data-name": "Path 9105",
    d: "M128.7,55.84a4.67,4.67,0,0,1-.178-4.975c-.109-.078-.185-.138-.266-.189a4.792,4.792,0,0,1-2.147-5.213,18.4,18.4,0,0,1,4.967-10.448l-.069-.138a17.043,17.043,0,0,0-2.295,1.457,13.428,13.428,0,0,0-4.684,8.863c-.274,2.494.368,4.643,2.66,6.023.334.2.3.445.251.742a3.536,3.536,0,0,0,.4,2.592,17.561,17.561,0,0,0,1.13,1.421l.231-.134",
    transform: "translate(-85.821 -30.806)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9106",
    "data-name": "Path 9106",
    d: "M432.836,134.1c2.15-1.2,4.042-2.555,4.735-5.029-1.1-.694-3.67-.349-5.007.676l2.15-.179.069.218c-1.048.471-2.09.954-3.146,1.408a4.937,4.937,0,0,0-2.678,1.752c-.453.778-.8,1.618-1.19,2.43l.156.083c.289-.38.576-.76.866-1.139a4.65,4.65,0,0,1,4.039-1.669c.355,0,.443.16.325.483-.112.3-.2.617-.318.967",
    transform: "translate(-427.769 -113.686)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9107",
    "data-name": "Path 9107",
    d: "M434.2,63.591c-.213-2.557-1.817-4.241-3.714-5.834.05.347.079.657.144.96.09.423-.07.511-.467.445a4.7,4.7,0,0,1-3.882-2.882c-.052-.125-.118-.245-.176-.368a.747.747,0,0,0-.182-.276c.114,1.62.429,3.134,1.919,4.132,1.208.81,2.38,1.675,3.566,2.517.075.053.137.124.339.31l-2.255-.59a5.449,5.449,0,0,0,4.708,1.585",
    transform: "translate(-424.184 -49.145)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9108",
    "data-name": "Path 9108",
    d: "M350.209,111.235a15.466,15.466,0,0,1,5.03,3.76c-.151-.27-.3-.542-.452-.809-.407-.708-.8-1.427-1.232-2.117a1.543,1.543,0,0,1-.008-1.759c.37-.588.818-1.127,1.254-1.717l-4.609,2.474.016.168",
    transform: "translate(-336.385 -95.921)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9109",
    "data-name": "Path 9109",
    d: "M390.176,111.322,386.1,113.5a14.468,14.468,0,0,1,4.349,3.12c-.088-.166-.17-.335-.264-.5-.338-.589-.652-1.195-1.027-1.76a1.4,1.4,0,0,1,.012-1.683c.3-.446.637-.864,1.008-1.362",
    transform: "translate(-375.781 -98.332)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9110",
    "data-name": "Path 9110",
    d: "M161.655,3.293c.531-.961,1.217-.68,1.914-.382A6.669,6.669,0,0,0,160.115,0a4.888,4.888,0,0,1,1.54,3.292",
    transform: "translate(-122.534 -0.001)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9111",
    "data-name": "Path 9111",
    d: "M199.787,15.518a5.471,5.471,0,0,0-2.287-2.029l.994,2.153c.288-.434.766-.4,1.293-.123",
    transform: "translate(-163.114 -11.915)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9112",
    "data-name": "Path 9112",
    d: "M227.044,25.918l.616,1.364,1.007-.187-1.564-1.27-.059.093",
    transform: "translate(-195.442 -22.811)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9113",
    "data-name": "Path 9113",
    d: "M249.084,38.914l.675-.324-1.206-.637-.047.087.578.873",
    transform: "translate(-219.038 -33.525)",
    fill: "#ccc"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCumulativeDeaths);
export default __webpack_public_path__ + "static/media/cumulativeDeaths.e974b754e4523f9ccce3e5d7297a33a5.svg";
export { ForwardRef as ReactComponent };